import { style } from '@vanilla-extract/css';

export const audioContainer = style({
  width: '100%',
  borderCollapse: 'collapse',
  paddingTop: '16px',
  paddingBottom: '16px',
  paddingLeft: 'var(--wt-padding)',
  paddingRight: 'var(--wt-padding)',
});
